import React from "react";

import {MuiIcon, MuiIconExternalProps} from './MuiIcon';

export const WarningIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue002'}</MuiIcon>
    );
}